module.exports = __webpack_public_path__ + "img/facts-grassfield.6aa7f7a2.svg";